export default "__VITE_ASSET__Bdl9i1kz__"